(() => {
  if (customElements.get('product-recommendations')) return;

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      if (!('IntersectionObserver' in window)) {
        this.load();
        return;
      }
      this.observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) return;
          this.observer.disconnect();
          this.load();
        },
        { rootMargin: '0px 0px 600px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    async fetchContent(url) {
      const response = await fetch(url);
      if (!response.ok) return null;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      return doc.querySelector('[data-recs-content]');
    }

    async load() {
      try {
        let content = await this.fetchContent(this.dataset.url);
        if (!content && !this.hasAttribute('data-has-fallback')) content = await this.fetchContent(this.dataset.fallbackUrl);
        if (content) {
          this.replaceChildren(content);
          window.theme?.initReveal?.(this);
        } else if (!this.querySelector('[data-recs-fallback]')) {
          this.hidden = true;
        }
      } catch (error) {
        if (!this.querySelector('[data-recs-fallback]')) this.hidden = true;
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
})();
